export const statusStyles: { [key: string]: string } = {
  success: "bg-green-100 text-green-800",
  processing: "bg-yellow-100 text-yellow-800",
  failed: "bg-gray-100 text-gray-800",
};

export const classNames = (...classes: string[]) => {
  return classes.filter(Boolean).join(" ");
};
